import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import unauthorizedImage from '../assets/common/under-construction.svg';

export default function UnauthorizedPage() {
  return (
    <Stack alignItems='center' justifyContent='center' gap={6} paddingTop={8}>
      <div>
        <Typography
          component='h2'
          textAlign='center'
          sx={{ color: 'grey.500', fontSize: '3rem', fontWeight: 500 }}
        >
          Unauthorized Access
        </Typography>
        <Typography fontSize='1.5rem' textAlign='center' sx={{ color: 'grey.500' }}>
          You do not have permission to access this page
        </Typography>
      </div>
      <Box component='img' src={unauthorizedImage} alt='' sx={{ width: '100%', maxWidth: 640 }} />
    </Stack>
  );
}
